import AssessmentQuestionnaireManagementContainer from './AssessmentQuestionnaireManagementContainer'
export default AssessmentQuestionnaireManagementContainer
